<template>
  <div class="report-history">
    <NavBar class="nav" :title="$t('history.历史记录')" :goBack="onClickLeft" />
    <Notice :top="noticeTop" />
    <div class="content">
      <div class="list-box">
        <template v-if="recordList && recordList.length">
          <div
            class="item"
            v-for="item in recordList"
            :key="item.id"
            @click="goRecord(item)"
          >
            <div class="infos">
              <div class="info">
                {{ item.title }}
              </div>
              <div class="time">
                {{ item.time_title }}：<span>{{
                  item.do_time | timeFilter
                }}</span>
              </div>
            </div>
            <van-tag round :color="statusColor[item.status_text] || ''">
              {{ item.status_text }}
            </van-tag>
          </div>
        </template>
        <van-empty v-else :description="$t('history.暂无记录')" />
      </div>
      <div class="tips">
        {{ $t("history.仅显示最近30天的记录") }}
      </div>
    </div>
  </div>
</template>

<script>
import { Notice } from "@/components/Notice";
import { getTicketRecordList } from "@/api/workOrder";

export default {
  name: "ReportResult",
  data() {
    return {
      recordList: null,
      statusColor: {
        [this.$t("history.待处理")]: "#ff976a",
        [this.$t("history.处理中")]: "#79A2FF",
        [this.$t("history.待补全")]: "#FF4D4D",
        [this.$t("history.已完结")]: "#4AAA2C",
      },
    };
  },
  components: { Notice },
  computed: {
    noticeTop() {
      // let height= document.getElementsByClassName('nav-bar')[0] && document.getElementsByClassName('nav-bar')[0].offsetHeight || 44;
      return 0;
    },
  },
  mounted() {
    this.getRecordList();
  },
  methods: {
    // $t('获取工单历史记录')
    getRecordList() {
      getTicketRecordList().then((res) => {
        if (res.code === 0) {
          this.recordList = res.data || [];
        }
      });
    },
    onClickLeft() {
      this.$router.back();
    },
    goRecord(data) {
      this.$router.push({
        name: "ReportRecord",
        query: {
          id: data.id,
          type: 0,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.report-history {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f1f1f1;
  .nav {
    flex: 0 0 auto;
  }
  .content {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 0;
    box-sizing: border-box;
    overflow: scroll;
    .list-box {
      width: 100%;
      // display: flex;
      // flex-direction: column;
      padding: 0 10px;
      box-sizing: border-box;
      background-color: #fff;
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 68px;
        font-size: 15px;
        box-sizing: border-box;

        border-bottom: 1px solid #f7f7f7;
        .infos {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .info {
            margin-bottom: 5px;
            color: #333;
            font-size: 13px;
            line-height: 18px;
          }
          .time {
            color: #999;
            font-size: 12px;
            line-height: 16px;
          }
        }
      }
    }
    .tips {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 15px 0;
      color: @fontColor;
      font-size: 13px;
    }
  }
}
.van-tag--round {
  width: fit-content !important;
  height: 24px;
  // padding: 2px 10px;
  line-height: 24px;
}
</style>
